import { createFileRoute } from "@tanstack/react-router";
import FdsTokenDiff from "lib/components/debug/fdsTokenDiff/FdsTokenDiff";
import withAuthentication from "../../components/withAuthentication";

export const Route = createFileRoute("/debug/fds-token-diff")({
  component: withAuthentication(FdsTokenDiff, { superAdmin: true }),
});
